/*
 * @Author: Christion.Young
 * @Date: 2021-01-12 18:13:54
 * @LastEditors: Christion.Young
 * @LastEditTime: 2025-08-14 14:00:00
 * @Description: 通用工具函数
 */

/**
 * @description: utils——guid
 * @param {*}
 * @return {*}
 */
export const utils = {
  guid: function () {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  },
};

/**
 * @description: 转换时间
 * @param {*}
 * @return {*}
 */
export const dateFormat = (date) => {
  let time = new Date(date);
  let year = time.getFullYear();
  let month =
    Number(Number(time.getMonth()) + 1) >= 10
      ? Number(time.getMonth()) + 1
      : "0" + Number(Number(time.getMonth()) + 1);
  let day =
    Number(time.getDate()) >= 10 ? time.getDate() : "0" + time.getDate();
  return `${year}-${month}-${day}`;
};

/**
 * @description: 惰性函数
 * @param { elementNode } dom  绑定事件的节点对象
 * @param { string } type  绑定的事件类型
 * @param { function } fn  回调函数
 * @return {*}
 */
export const LazyEvent = {
  on(dom, type, fn) {
    if (dom.addEventListener) {
      LazyEvent.on = (dom, type, fn) => {
        dom.addEventListener(type, fn, false);
      };
    } else if (dom.attachEvent) {
      LazyEvent.on = (dom, type, fn) => {
        dom.attachEvent("on" + type, fn);
      };
    } else {
      LazyEvent.on = (dom, type, fn) => {
        dom["on" + type] = fn;
      };
    }
    LazyEvent.on(dom, type, fn);
  },
  stop(dom, type, fn) {
    if (dom.removeEventListener) {
      LazyEvent.stop = (dom, type, fn) => {
        dom.removeEventListener(type, fn);
      };
    } else if (dom.detachEvent) {
      LazyEvent.stop = (dom, type, fn) => {
        dom.detachEvent(type, fn);
      };
    } else {
      LazyEvent.stop = (dom, type) => {
        dom["on" + type] = null;
      };
    }
    LazyEvent.stop(dom, type, fn);
  },
};

/**
 * @description:筛选扩展方法
 * @param { object } confing  筛选配置，数据类型: Object，数据格式："控制字段": "status具体字段"，例如："enable":"1"
 * @param { object } obj  筛选条件的控制对象，数据类型：Object，数据格式："控制字段": true，例如："enable":true
 * @param { array } data  需要筛选的数据，数据类型：Array，数据格式：[{}, {}, {}]
 * @param { string } field    筛选依据字段，默认值为status
 * @return {*}
 */
export const filterExtend = (config, obj, data, field = "status") => {
  let _d = data,
    _b = obj,
    _c = config,
    _array = [],
    _obj = {},
    _f = field;
  if (Object.keys(_b).length === 0) return _d;
  if (!_d && _d.length == 0) return _array;
  _d.map((v) => {
    !_obj[v[_f]]
      ? ((_obj[v[_f]] = []), _obj[v[_f]].push(v))
      : _obj[v[_f]].push(v);
  });
  for (let k in _b) {
    if (_b[k]) _obj[_c[k]] && _array.push(..._obj[_c[k]]);
  }
  return _array;
};

/**
 * @description: 防抖函数
 * @param {*} func  需要防抖的函数
 * @param {*} wait  延迟时间
 * @param {*} immediate 是否立刻执行
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout;
  return function (...args) {
    let self = this;
    if (timeout) clearTimeout(timeout);
    if (immediate) {
      let callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait);
      if (callNow) func.apply(self, args);
    } else {
      timeout = setTimeout(function () {
        func.apply(self, args);
      }, wait);
    }
  };
}

/**
 * @description: 处理缓释结果表格数据
 * @param {*}
 * @return {*}
 */
export function buildTableData(
  data,
  headField = "xAisa",
  dataListField = "data",
  childField = "children",
  setField = "data"
) {
  let len = data[headField].length;
  function loop(loopData) {
    for (let i = 0, leng = loopData.length; i < leng; i++) {
      for (let j = 0; j < len; j++) {
        loopData[i][setField + (j + 1)] = loopData[i].values[j];
      }
      if (loopData[i][childField] && loopData[i][childField].length !== 0) {
        loop(loopData[i][childField]);
      }
    }
  }
  loop(data[dataListField]);
  return data;
}

/**
 * @description: 递归角色相关树结构，获取已经勾选的节点
 * @param {*} data
 * @return {*}
 */
export function getCheckedNode(data) {
  if (!data || data.length === 0) return [];
  let _readyCheck = [],
    _objArray = [];
  for (let i = 0, len = data.length; i < len; i++) {
    // 有子模块，没有子菜单，进入递归
    if (
      data[i].childModule &&
      data[i].childModule.length !== 0 &&
      data[i].menu.length === 0
    ) {
      let trunData = getCheckedNode(data[i].childModule);
      _readyCheck.push(...trunData.readyArray);
      _objArray.push(...trunData.dataArray);
    }
    data[i].existed && data[i].menuId && _readyCheck.push(data[i].menuId);
    data[i].existed &&
      data[i].menuId &&
      _objArray.push({
        menuId: data[i].menuId,
        moduleId: data[i].moduleId,
      });
    // 子菜单在 menu 中
    if (data[i].menu && data[i].menu.length !== 0) {
      for (let j = 0, leng = data[i].menu.length; j < leng; j++) {
        data[i].menu[j].existed && _readyCheck.push(data[i].menu[j].menuId);
        data[i].menu[j].existed &&
          _objArray.push({
            menuId: data[i].menu[j].menuId,
            moduleId: data[i].menu[j].moduleId,
          });

        // 如果子节点存在menu中
        if (data[i].menu[j].menu && data[i].menu[j].menu.length !== 0) {
          let trunData = getCheckedNode(data[i].menu[j].menu);
          _readyCheck.push(...trunData.readyArray);
          _objArray.push(...trunData.dataArray);
        }

        // 如果子节点存在childMenu中
        if (
          data[i].menu[j].childMenu &&
          data[i].menu[j].childMenu.length !== 0
        ) {
          let trunData = getCheckedNode(data[i].menu[j].childMenu);
          _readyCheck.push(...trunData.readyArray);
          _objArray.push(...trunData.dataArray);
        }
      }
    }

    // 子菜单在 childMenu 中
    if (data[i].childMenu && data[i].childMenu.length !== 0) {
      for (let j = 0, leng = data[i].childMenu.length; j < leng; j++) {
        data[i].childMenu[j].existed &&
          _readyCheck.push(data[i].childMenu[j].menuId);
        data[i].childMenu[j].existed &&
          _objArray.push({
            menuId: data[i].childMenu[j].menuId,
            moduleId: data[i].childMenu[j].moduleId,
          });

        // 如果子节点存在menu中
        if (
          data[i].childMenu[j].menu &&
          data[i].childMenu[j].menu.length !== 0
        ) {
          let trunData = getCheckedNode(data[i].childMenu[j].menu);
          _readyCheck.push(...trunData.readyArray);
          _objArray.push(...trunData.dataArray);
        }

        // 如果子节点存在childMenu中
        if (
          data[i].childMenu[j].childMenu &&
          data[i].childMenu[j].childMenu.length !== 0
        ) {
          let trunData = getCheckedNode(data[i].menu[j].childMenu);
          _readyCheck.push(...trunData.readyArray);
          _objArray.push(...trunData.dataArray);
        }
      }
    }
  }
  return {
    readyArray: _readyCheck,
    dataArray: _objArray,
  };
}

/**
 * @description: 分解树形结构 - 适用于角色授权树
 * @param {*} treeData
 * @param {*} childrenField
 * @return {*}
 */
export function resolveTree(treeData, childrenField = "children") {
  let getArray = [],
    child = null;
  // 若存在子节点
  if (treeData[childrenField].length !== 0) {
    child = treeData[childrenField];
    delete treeData[childrenField];
  }
  // 存储当前节点
  getArray.push(treeData);
  // 遍历子节点
  if (child) {
    for (let i = 0, len = child.length; i < len; i++) {
      let turnData = resolveTree(child[i], childrenField);
      getArray.push(...turnData);
    }
  }
  return getArray;
}

/**
 * @description: 获取菜单的存在菜单的第一个节点
 * @param {*} treeData
 * @return {*}
 */
export function getFirstNode(treeData) {
  let _str = "";
  if (treeData.length === 0 || !treeData) return _str;
  for (let i = 0, len = treeData.length; i < len; i++) {
    if (_str) break;
    // 存在子菜单
    if (treeData[i].childList && treeData[i].childList.length !== 0) {
      _str = getFirstNode(treeData[i].childList);
    }
    // 不存在子菜单且存在URL
    if (
      (!treeData[i].childList || treeData[i].childList.length === 0) &&
      treeData[i].menuUrl
    ) {
      _str = treeData[i].menuUrl;
    }
  }
  return _str;
}

/**
 * @description: 获取数组对象对应字段值
 * @param {*}
 * @return {*}
 */
export function getLabel(
  val,
  list = [],
  useVal = "value",
  exportVal = "label"
) {
  var label = "";
  for (let i = 0; i < list.length; i++) {
    if (val == list[i][useVal]) {
      label = list[i][exportVal];
    }
  }
  if (!label) {
    label = val;
  }
  return label;
}

export function getNameByCode(
  val,
  list = [],
  useVal = "code",
  exportVal = "name"
) {
  var label = "";
  for (let i = 0; i < list.length; i++) {
    if (val == list[i][useVal]) {
      label = list[i][exportVal];
    }
  }
  if (!label) {
    label = val;
  }
  return label;
}

/**
 * @description: 根据传入字符,递归获取具有层级结构数据中对应节点属性值，层级结构最外层为[]或{}均可。
 * @param {*}onlyCode 传入的字符
 * @param {*}treeData 递归的树形数据
 * @param {*}code 节点编码，不传默认是value
 * @param {*}name 节点名称，不传默认是label
 * @param {*}childName 内嵌数组对象集合的属性名称，不传默认为children
 * @return {*}
 */
export const getNameFromTree = (
  onlyCode,
  treeData,
  code = "value",
  name = "label",
  childName = "children"
) => {
  let resultName = "";
  if (!treeData || !onlyCode) return "";
  const getChild = (treeData) => {
    // 外层是对象的处理
    if (!(treeData instanceof Array)) {
      if (onlyCode == treeData[code]) {
        resultName = treeData[name];
        return resultName;
      }
      if (treeData[childName] && treeData[childName].length > 0) {
        getChild(treeData[childName]);
      }
    }
    // 外层是数组的处理
    for (let i = 0; i < treeData.length; i++) {
      if (onlyCode == treeData[i][code]) {
        resultName = treeData[i][name];
        break;
      } else {
        resultName = "";
      }
      if (treeData[i][childName] && treeData[i][childName].length > 0) {
        getChild(treeData[i][childName]);
      }
    }
    return resultName;
  };
  return getChild(treeData);
};

/**
 * @description: 将LIST装换成TREE
 * @param {Object} myId 数据主键id
 * @param {Object} pId  数据关联的父级id
 * @param {Object} list list集合
 * @return {*}
 */
export const listToTree = (myId = "id", pId = "parentId", list) => {
  if (list.length == 0) {
    return list;
  }
  function exists(list, parentId) {
    for (var i = 0; i < list.length; i++) {
      if (list[i][myId] == parentId) return true;
    }
    return false;
  }
  var nodes = [];
  for (var i = 0; i < list.length; i++) {
    var row = list[i];
    if (!exists(list, row[pId])) {
      nodes.push(row);
    }
  }
  var toDo = [];
  // eslint-disable-next-line no-redeclare
  for (var i = 0; i < nodes.length; i++) {
    toDo.push(nodes[i]);
  }
  while (toDo.length) {
    var node = toDo.shift();
    // eslint-disable-next-line no-redeclare
    for (var i = 0; i < list.length; i++) {
      // eslint-disable-next-line no-redeclare
      var row = list[i];
      if (row[pId] == node[myId]) {
        if (node.children) {
          node.children.push(row);
        } else {
          node.children = [row];
        }
        toDo.push(row);
      }
    }
  }
  return nodes;
};

/**
 * @description: TABLE表格展示列
 * @param {Arrey} checkList 选中列中文字段
 * @param {Arrey} textData 参考列字段
 * @return {Arrey}
 */
export const tableDataPick = (checkList = [], textData = []) => {
  let arr = [],
    arr1 = textData,
    arr2 = checkList;
  for (let i = 0; i < arr1.length; i++) {
    let flg = false;
    for (let j = 0; j < arr2.length; j++) {
      if (arr1[i].label === arr2[j]) {
        flg = true;
      }
    }
    arr.push(flg);
  }
  return arr;
};

/**
 * @description: 随机字符
 * @param {*}
 * @return {*}
 */
export const randomStr = {
  guid: function () {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  },
};

/**
 * @description: 深度拷贝
 * @param {*}
 * @return {*}
 */
export const deepClone = (source) => {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "deepClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
};

/**
 * @description: 防抖函数（备用版本）
 * @param {*}
 * @return {*}
 */
export const _debounce = (handler, delay, context) => {
  let timer = null;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(() => {
      handler.apply(context);
    }, delay);
  };
};

/**
 * @description: 节流函数
 * @param {*}
 * @return {*}
 */
export const _throttle = (handler, wait, context) => {
  let lastTime = 0;
  return function () {
    let now = new Date().getTime();
    if (now - lastTime > wait) {
      handler.apply(context);
      lastTime = now;
    }
  };
};

/**
 * @description: 手机号隐私处理
 * 只显示前三位和后四位，中间用星号替代
 * @param {string} phone - 原始手机号
 * @return {string} 处理后的手机号，如：138****5678
 */
export const formatPhonePrivacy = (phone) => {
  if (!phone || typeof phone !== "string") {
    return phone;
  }

  // 去除空格和其他字符，只保留数字
  const cleanPhone = phone.replace(/\D/g, "");

  // 如果不是11位手机号，直接返回原值
  if (cleanPhone.length !== 11) {
    return phone;
  }

  // 格式化为 138****5678
  return cleanPhone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
};
